module.exports = __webpack_public_path__ + "img/1492339187.eebb6260.jpg";